module.exports = __webpack_public_path__ + "static/media/sustained_decliner_white.c9b3dbc1.svg";